module.exports = {
  routePrivacy: 'privacy'
}
